var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',[_vm._v(" query: "+_vm._s(_vm.query)+" "),_c('hr'),_vm._v(" items loaded: "),_c('ul',_vm._l((_vm.chatPlans.items),function(item){return _c('li',{key:item.id},[_vm._v(" "+_vm._s(item.name)+" [ "+_vm._s(item.code)+" ] ")])}),0)]),_c('hr')])
}
var staticRenderFns = []

export { render, staticRenderFns }